<template>
  <div class="AiPopinCard">
    <div class="AiPopinCard-head">
      <ai-button slim variant="tertiary" @click="$emit('close')">
        <ai-icon name="close" />
      </ai-button>
    </div>

    <div class="AiPopin-body">
      <slot>
        <ai-typo v-if="title" as="div" variant="paragraph-01-bold">
          {{ title }}
        </ai-typo>

        <ai-typo
          v-if="description"
          as="p"
          variant="paragraph-03-regular"
          class="AiPopin-description">
          {{ description }}
        </ai-typo>

        <slot name="actions" />
      </slot>
    </div>
  </div>
</template>

<script setup lang="ts">
type Props = {
  title?: string;
  description?: string;
};

defineProps<Props>();

type Emits = {
  (event: 'close'): void;
};
defineEmits<Emits>();
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';
@use '@/assets/styles/utilities/mq';
@use '@/assets/styles/utilities/colors';
@use '@/assets/styles/themes/rixos/constants' as RixosTheme;

.AiPopinCard {
  display: inline-block;
  padding: constants.$inner-04;
  background-color: colors.$gold-100;
  width: 100%;

  @media (mq.$from-medium) {
    max-width: 50%;
    text-align: center;
  }
}

.AiPopinCard-head {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: constants.$margin-01;
}

.AiPopin-body {
  display: inline-block;
  text-align: center;
  padding-left: constants.$padding-01;
  padding-right: constants.$padding-01;
  padding-bottom: constants.$padding-04;

  @media (mq.$from-medium) {
    padding-left: constants.$padding-06;
    padding-right: constants.$padding-06;
  }
}

.AiPopin-description {
  margin-bottom: constants.$margin-02;
}

.theme.rixos {
  .AiPopinCard {
    background: RixosTheme.$color-banner-gray;

    :deep(.AiButton--primary) {
      background: RixosTheme.$color-primary-black;

      .AiTypo {
        color: colors.$white;
      }
    }
  }
}
</style>
